import {Component, OnInit, ViewChild} from '@angular/core';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {User} from '../../Interfaces/User';
import {AppComponent} from '../../app.component';
import {QueryService} from '../../Services/query.service';
import {Subscription} from 'rxjs';
import {PeelOffPileParams} from '../../Interfaces/PeelOffPileParams';
import {PeelOffPileView} from '../../Interfaces/PeelOffPileView';
import {UntypedFormControl} from '@angular/forms';
import {SelectionModel} from '@angular/cdk/collections';
import {PeelOffParent} from '../../Interfaces/PeelOffParent';
import {SharedVarService} from '../shared-service.service';
import {Router} from '@angular/router';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-peel-off-pile',
  templateUrl: './peel-off-pile.component.html',
  styleUrls: ['./peel-off-pile.component.css']
})
export class PeelOffPileComponent implements OnInit {
  public savedList: string;
  public vessel: string;
  public group: string;
  public savedLists : {code:string, description:string}[] = [];
  public vessels : {code:string, description:string}[] = [];
  public groups : {code:string, description:string}[] = [];
  public showQuickView: boolean = false;
  txtFromArea: string;
  containerNum: string;
  public submitted: boolean = false;
  public oneIsInAlready: boolean = false;
  public submitted2: boolean = false;
  public badChars: boolean = false;
  public didntEnterShit: boolean = false;
  public minNotMet: boolean = false;
  public oddOnly: boolean = false;
  public evenOnly: boolean = false;
  public badSearch: boolean = false;
  public notANumber: boolean = false;
  showTypes: boolean = true;
  private  myUser: User;
  private  peelOffParent: PeelOffParent;
  private  myParams: PeelOffPileParams;
  private  peelOffView: PeelOffPileView;
  private clientRequest: ClientRequest;
  private subscription: Subscription;
  quickViewData: MatTableDataSource<PeelOffPileView>;
  search1: UntypedFormControl;
  public qvColumns: string[];
  private allChecked: boolean = false;
  noneSelected: boolean = false;
  private selection: SelectionModel<PeelOffPileView>;
  txtArray2: string [] = [];
  maherError: boolean = false;
  maherError2: boolean = false;
  N4Error: boolean = false;
  N4Error2: boolean = false;
  concatMaherError: string = '';
  wrongCount40: boolean = false;
  wrongCount45: boolean = false;
  wrongCountReefer: boolean = false;
  concatN4Error: string = '';
  public inSearch: boolean = false;
  public ipadAppear: boolean = true;
  ipadApp: boolean = false;

  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.quickViewData!=undefined){
      this.quickViewData.sort = sort;
    }
  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData!=undefined){
      this.quickViewData.paginator = pag;
    }
  }

  dontShowSearch(){
    if (this.ipadApp){
      this.inSearch = true;
      this.ipadAppear = false;
    }
  }

  returnToSearch(){
    if (this.ipadApp){
      this.inSearch = false;
      this.ipadAppear = true;
      this.showQuickView = false;
    }
  }



  constructor(private myApp:AppComponent,private  globalEventsManager: GlobalEventsManager, private  queryService: QueryService,private router: Router, private service: SharedVarService) {
    this.qvColumns = ["check","unit_id","line_op","ves_voy","maherError"];

    this.myUser = this.myApp.user;
/*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = null
  //  this.myUser.company_code ="EGN"
   this.myUser.company_code ="B2696"
    this.myUser.company_name= "MAHER TERMINALS, LLC"
    this.myUser.city= "HOUSTON"
    this.myUser.email_address= null
    this.myUser.fax_number= null
    this.myUser.first_name= "Csp Craig"
    this.myUser.last_name= "Miller"
    this.myUser. maherError= null
    this.myUser.old_password= null
    this.myUser.password= ""
    this.myUser.phone_number= null
    this.myUser.company_scac= null
    this.myUser.state= "TX"
    this.myUser.userMenuReportItemsView= null
    this.myUser.user_gkey= "8237887"
      // this.myUser.role= "AGENT"
    //this.myUser.role= "LINEOP"
   this.myUser.role= "HAULIER"
    this.myUser.username="CSPTRUCKER"
    this.myUser.zip="07201"
    this.myUser.canSeeAllData = "0";


 */

  }

  ngOnInit() {
    this.search1 = new UntypedFormControl();
    this.savedLists = [];
    this.savedLists.push({"code": "40", "description": "40 Foot"});
    this.savedLists.push({"code": "45", "description": "45 Foot"});
    this.savedList = this.savedLists[0].code;
    this.initScreen();
  }


  wipeOutScreen(){
    this.showQuickView = false;
    this.maherError = false;
    this.maherError2 = false;
    this.N4Error = false;
    this.N4Error2 = false;
    this.concatN4Error = "";
    this.concatMaherError = null;
  }

  setCheckedField(){
    this.maherError = false;
    this.maherError2 = false;
    this.N4Error = false;
    this.N4Error2 = false;
    this.concatN4Error = "";
    this.concatMaherError = null;
    if (this.showTypes){
      this.showTypes = false;
    }else{
      this.showTypes = true;
    }
  }


  masterToggle(rowIn: PeelOffPileView, selected:boolean) {
    this.maherError2 = null;
    this.maherError = null;
    this.N4Error2 = null;
    this.N4Error = null;
    this.concatMaherError = null;
    this.concatN4Error = null;
    if (!selected){
      this.selection.select(rowIn);
      this.noneSelected = false;
    }else{
      this.selection.deselect(rowIn);
    }
  }

  checkAll(){
    if (!this.allChecked){
      this.noneSelected = false;
      this.quickViewData.data.forEach(row => {
        this.selection.select(row)
      })
      this.allChecked = true;
    }else{
      this.quickViewData.data.forEach(row => {
        this.selection.deselect(row)
      })
      this.allChecked = false;
    }
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }


  initScreen(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    const lhsUserObs$ = this.queryService.peelOffPileInit(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (param) => {
        this.myParams = param;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.groups = [];
        this.vessels = [];
        if (this.myParams.groupCodes!=null){
          for (var groups of this.myParams.groupCodes){
            this.groups.push({"code": groups.gkey, "description": groups.description});
          }
          this.group = this.groups[0].code;
        }
        if (this.myParams.vesselVisits!=null){
          for (var vessels of this.myParams.vesselVisits){
            this.vessels.push({"code": vessels.gkey, "description": vessels.description});
          }
          this.vessel = this.vessels[0].code;
        }

      });
  }

  savePeel(){
      this.submitted2 = true;
      this.badSearch = false;
      this.didntEnterShit = false;
      this.minNotMet = false;
      this.maherError2 = false;
      this.noneSelected = false;
      this.N4Error2 = false;
      this.concatN4Error = "";
      this.concatMaherError = "";

      if (this.selection.selected.length==0){
        this.noneSelected = true;
        return;
      }


      this.clientRequest = null;
      this.clientRequest = {} as ClientRequest;
      this.peelOffParent = null;
      this.peelOffParent = {} as PeelOffParent;

      this.peelOffParent.groupCodeGkey = this.group;
      this.peelOffParent.vesselVoyageGkey = this.vessel;
      if (this.showTypes){
        this.peelOffParent.isReefer = 'N';
        this.peelOffParent.containerLength = this.savedList;
      }else{
        this.peelOffParent.isReefer = 'Y';
        this.peelOffParent.containerLength = "40";

      }


      this.clientRequest.user = this.myUser;
      this.clientRequest.requestData = [];
      this.peelOffParent.peelOffPileViews = [];

      if (this.selection.selected.length>0){
        if (this.showTypes){
          if (this.savedList=="40"){
            if (this.selection.selected.length % parseFloat(this.myParams.minCountDry40.replace(/,/g, '')) === 0){
            }else{
              this.wrongCount40 = true;
              return;
            }
          }else{
            if (this.selection.selected.length % parseFloat(this.myParams.minCountDry45.replace(/,/g, '')) === 0){
            }else{
              this.wrongCount45 = true;
              return;
            }
          }
        }else{
          if (this.selection.selected.length < parseFloat(this.myParams.minCountReefer40.replace(/,/g, ''))){
            this.minNotMet = true;
            return;
          }
        }
      }



      for (var items of this.selection.selected){
        this.peelOffParent.peelOffPileViews.push(items);
      }


      this.clientRequest.requestData[0] = this.peelOffParent;

      var lhsUserObs$ = this.queryService.peelOffPileProcess(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (conts) => {
          this.peelOffParent = conts;
        },
        error => {
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);
          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
          if (this.peelOffParent.maherError!=null) {
            this.maherError2 = true;
            this.concatMaherError = this.peelOffParent.maherError;
          }else if (this.peelOffParent.navisErrors!=null){
            this.N4Error2 = true;
            for (var errs of this.peelOffParent.navisErrors){
              this.concatN4Error = this.concatN4Error + this.peelOffParent.navisErrors;
            }
          }else{
            this.submitted2= false;
            this.showQuickView = false;
            this.txtFromArea = "";
            this.myApp.showSuccessBanner("","records saved successfully","peelPiles");
          }


        });
    }






  getSearchItems(){
    if (this.oneIsInAlready){
      return;
    }

  this.showQuickView = false;
  this.submitted = true;
  this.oneIsInAlready = true;
  this.badSearch = false;
  this.badChars = false;
  this.didntEnterShit = false;
  this.minNotMet = false;
  this.oddOnly = false;
  this.evenOnly = false;
  this.maherError = false;
  this.maherError2 = false;
  this.N4Error = false;
  this.N4Error2 = false;
  this.concatN4Error = "";
  this.concatMaherError = null;

  this.wrongCount40 = false;
  this.wrongCount45 = false;
  this.wrongCountReefer = false;

  if (this.txtFromArea == undefined) {
    this.didntEnterShit = true;
    this.oneIsInAlready = false;

    return;
  }

    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
  this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);

  if (this.txtArray2.length == 0) {
    this.didntEnterShit = true;
    this.oneIsInAlready = false;
    return;
  }
  this.didntEnterShit = false;
  var _i = this.txtArray2.length;
  while (_i--) {
    this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
    if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
      this.containerNum = this.txtArray2[_i].valueOf();
      this.badChars = true;
      this.oneIsInAlready = false;
      return;
    }
    if (this.txtArray2[_i].valueOf() == "") {
      this.txtArray2.splice(_i, 1);
    }
  }
  if (this.txtArray2.length == 0) {
    this.didntEnterShit = true;
    this.oneIsInAlready = false;
    return;
  }else{
    if (this.showTypes){
      if (this.savedList=="40"){
        if (this.txtArray2.length % parseFloat(this.myParams.minCountDry40.replace(/,/g, '')) === 0){
        }else{
          this.wrongCount40 = true;
          this.oneIsInAlready = false;
          return;
        }
      }else{
        if (this.txtArray2.length % parseFloat(this.myParams.minCountDry45.replace(/,/g, '')) === 0){
        }else{
          this.wrongCount45 = true;
          this.oneIsInAlready = false;
          return;
        }
      }
    }else{
      if (this.txtArray2.length < parseFloat(this.myParams.minCountReefer40.replace(/,/g, ''))){
        this.minNotMet = true;
        this.oneIsInAlready = false;
        return;
      }
    }

  }
  this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);




  this.clientRequest = null;
  this.clientRequest = {} as ClientRequest;
  this.peelOffParent = null;
  this.peelOffParent = {} as PeelOffParent;

  this.peelOffParent.groupCodeGkey = this.group;
  this.peelOffParent.vesselVoyageGkey = this.vessel;
  if (this.showTypes){
    this.peelOffParent.isReefer = 'N';
    this.peelOffParent.containerLength = this.savedList;
  }else{
    this.peelOffParent.isReefer = 'Y';
    this.peelOffParent.containerLength = "40";

  }


  this.clientRequest.user = this.myUser;
  this.clientRequest.requestData = [];
  this.peelOffParent.peelOffPileViews = [];
  for (var items of this.txtArray2){
    this.peelOffView = {} as PeelOffPileView;
    this.peelOffView.unit_id = items.valueOf();
    this.peelOffParent.peelOffPileViews.push(this.peelOffView);
  }
  this.clientRequest.requestData[0] = this.peelOffParent;

  var lhsUserObs$ = this.queryService.peelOffPileGetContainers(this.clientRequest);
  this.subscription = lhsUserObs$.subscribe(
    (conts) => {
      this.peelOffParent = conts;
    },
    error => {
      if (error.status == "401") {
        this.globalEventsManager.showLogin.emit(true);

        this.router.navigate(["login"]);
      } else {
        this.myApp.openDialog(error.message)
      }
    },
    () => {
      this.oneIsInAlready = false;

      if (this.peelOffParent.maherError!=null) {
        this.maherError = true;
      }else if (this.peelOffParent.navisErrors!=null){
        this.N4Error = true;
        for (var errs of this.peelOffParent.navisErrors){
          this.concatN4Error = this.concatN4Error + this.peelOffParent.navisErrors;
        }
      }else{
        this.submitted = false;
        this.showQuickView = true;
        if (window.innerWidth > 750 && window.innerWidth <1025){
          this.ipadAppear = false;
        }
        this.search1.reset();
        this.quickViewData = new MatTableDataSource<PeelOffPileView>(this.peelOffParent.peelOffPileViews);
        this.selection = null;
        this.selection = new SelectionModel<PeelOffPileView>(true);
      }
    });

}

}
